var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"menu-icon-item",class:{ 'active' : _vm.active }},[_c('i',{class:_vm.link.icon}),(_vm.showName)?_c('span',[_vm._v(_vm._s(_vm.link.title))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }